import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FiBookOpen, FiFileText, FiGlobe, FiGrid, FiPackage, FiUsers } from "react-icons/fi";
import { MainPermissionContext } from "../context/MainPermissionContext";
import { MainProfileContext } from "../context/MainProfileContext";

const actions = [
  { label: "Bookings", description: "Review and manage customer bookings", to: "/booking", module: "Booking", action: "Booking View", icon: FiBookOpen },
  { label: "Users", description: "Manage staff accounts and access", to: "/users", module: "Users", action: "User View", icon: FiUsers },
  { label: "Products", description: "Maintain vehicles and product content", to: "/products", module: "Products", action: "Products View", icon: FiPackage },
  { label: "Catalogs", description: "Organize fleet categories and brands", to: "/catalogs", module: "Catalogs", action: "Catalogs View", icon: FiGrid },
  { label: "Blogs", description: "Create and maintain editorial content", to: "/blogs", module: "Blogs", action: "Blogs View", icon: FiFileText },
  { label: "News", description: "Publish news and updates", to: "/news", module: "News", action: "News View", icon: FiFileText },
  { label: "Web content", description: "Update public website sections", to: "/webcontent", module: "WebContents", action: "WebContents View", icon: FiGlobe },
];

const MainDashboard = () => {
  const { permissionlist } = useContext(MainPermissionContext);
  const { profileData } = useContext(MainProfileContext);
  const visibleActions = actions.filter(({ module, action }) => permissionlist?.[module]?.includes(action));

  return (
    <section className="adminDashboard">
      <div className="pageHeading">
        <div>
          <span className="pageEyebrow">Overview</span>
          <h1>Welcome back{profileData?.name ? `, ${profileData.name}` : ""}</h1>
          <p>Access the areas available to your account and continue managing QuickLease.</p>
        </div>
      </div>

      <section className="dashboardHero" aria-label="QuickLease administration">
        <div>
          <span className="dashboardHero__label">QuickLease Admin</span>
          <h2>Everything you need to manage the rental experience.</h2>
          <p>Your navigation and available actions are based on your current role and permissions.</p>
        </div>
        <FiGrid aria-hidden="true" />
      </section>

      <div className="sectionHeading">
        <div><h2>Quick actions</h2><p>Frequently used administration areas</p></div>
      </div>
      {visibleActions.length ? (
        <div className="quickActionGrid">
          {visibleActions.map(({ label, description, to, icon: Icon }) => (
            <Link className="quickActionCard" to={to} key={to}>
              <span className="quickActionCard__icon"><Icon aria-hidden="true" /></span>
              <span><strong>{label}</strong><small>{description}</small></span>
              <span className="quickActionCard__arrow" aria-hidden="true">&#8250;</span>
            </Link>
          ))}
        </div>
      ) : (
        <div className="adminEmptyState"><FiGrid /><h3>No modules available</h3><p>Your role does not currently include access to an administration module.</p></div>
      )}
    </section>
  );
};

export default MainDashboard;
